(function() {
    var closeAudioSettingsHandler;
    var keyboardEventHandler;
    var resizeEventListener;
    var orientationChangeEventListener;
    let closeAndReopen;
    let imageBasePath = IMAGES_BASEPATH;

    function launchPlayer(options) {

        closeAndReopen = false;
        if(window['dlsAudioPlayer'].player) {
            closeAndReopen = true;
            window['dlsAudioPlayer'].destroyPlayer();
        }

        if(window['dlsVideoPlayer'].player) {
            window['dlsVideoPlayer'].destroyPlayer()
        }

        const controls = ` \
            <div class="plyr__controls"> \
                <div class="prgrs"> \
                    <button qid="aud-22" class="plyr__control dragger" id="verticalDrag" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.DRAG+`">\
                        <img src="Vertical_Drag.svg"> \
                    </button>\
                    <button qid="aud-20" class="plyr__control" id="enter-fullscreen-audio-mobile" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.ENTER_FULLSCREEN+`">\
                        <i class="nemo-font nemo-fullscreen"></i> \
                    </button>\
                    <button qid="aud-5" type="button" class="plyr__control playpause" aria-label="Play" data-plyr="play" id="playPauseButton1" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.PLAY+`"> \
                        <div class="icon--pressed"><span class="glyph"><i class="fa fa-pause" aria-hidden="true"></i></span></div> \
                        <div class="icon--not-pressed"><span class="glyph"><i class="fa fa-play" aria-hidden="true"></i></span></div> \
                    </button> \
                    <div class="plyr__time plyr__time--current" aria-label="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.CURRENT_TIME+`">00:00</div> \
                    <div class="plyr__progress"> \
                        <div class="letter-wrapper start-flag"> \
                            <img class="start-flag-icon" src="assets/img/Flag_big.png"> \
                        </div> \
                        <div class="letter-wrapper end-flag"> \
                            <img class="end-flag-icon" src="assets/img/Flag_big.png"> \
                        </div> \
                        <div id="progress-background" class="progress-background-styles" style="background-size: 6.5px 5px, 205.25px 5px;background-position: 0px, 6.5px;"></div> \
                        <div id ="gradient-background-left" class="gradient-background-styles-left"></div> \
                        <div id ="gradient-background-right" class="gradient-background-styles-right"></div> \
                        <input class="audio-progress-bar" qid="aud-1" style="color:transparent;" data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.SEEK+`" title="0"> \
                        <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress> \
                        <span role="tooltip" class="plyr__tooltip">00:00</span> \
                    </div> \
                    <div class="plyr__time plyr__time--duration" aria-label="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.DURATION+`">00:00</div> \
                    <button qid="aud-17" class="plyr__control" id="close-mobile" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.CLOSE+`">\
                        <i class="nemo-font nemo-cross"></i> \
                    </button>\
                </div> \
                <div class="ctrls-main mb-3"> \
                    <div class="ctrls"> \
                        <button qid="aud-2" type="button" class="plyr__control subs" id="subtitle-button" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.ENABLE_SUBTITLES+`"> \
                            <img src="assets/img/captions_new.svg" class="caption-svg-mobile nemo-caption"> \
                            <img src="assets/img/captions_new_fill_purple.svg" class="caption-svg-mobile-active nemo-caption"> \
                        </button> \
                        <button qid="aud-3" type="button" class="plyr__control loop-button" data-plyr="loop" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.START_LOOP+`"> \
                            <i id="loop-glyph" class="nemo-font nemo-loop"></i>\
                        </button> \
                        <button qid="aud-4" type="button" class="plyr__control bw5" id="rewind" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.REWIND+`"> \
                            <i class="nemo-font nemo-refresh"></i> \
                            <span class="textinrew">-5s</span> \
                        </button> \
                        <button qid="aud-5" type="button" class="plyr__control playpause" aria-label="Play" data-plyr="play" id="playPauseButton2" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.PLAY+`"> \
                            <div class="icon--pressed"><span class="glyph"><i class="fa fa-pause" aria-hidden="true"></i></span></div> \
                            <div class="icon--not-pressed"><span class="glyph"><i class="fa fa-play" aria-hidden="true"></i></span></div> \
                        </button> \
                        <button qid="aud-6" type="button" class="plyr__control fw5" id="forward" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.FORWARD+`"> \
                            <i class="nemo-font nemo-refresh"></i> \
                            <span class="textinfwd">+5s</span>\
                        </button> \
                        <button qid="aud-21" type="button" class="plyr__control transcript" id="transcriptBtn" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.ENABLE_TRANSCRIPTS+`"> \
                            <img src="assets/img/transcripts_new.svg" class="transcript-svg-mobile"> \
                            <img src="assets/img/transcripts_new_fill_purple.svg" class="transcript-svg-mobile-active"> \
                            </button> \
                        <div class="sets"> \
                            <button qid="aud-7" type="button" class="plyr__control setting" data-plyr="settings" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.SETTINGS+`"> \
                                <i class="nemo-font nemo-settings"></i> \
                            </button> \
                            <div class="setting-section"> \
                                <div class="setting-container" id="setting-container"> \
                                  <div class="volume-control-container"> \
                                    <p>`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.VOLUME+`</p> \
                                    <div class="volume-container" id="volume-container"> \
                                        <span class="volume-icon" aria-label="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.VOLUME+`"><img src="assets/img/Speaker_Icon.svg" /></span> \
                                        <input qid="aud-9" class="volume-seekbar" data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.VOLUME+`"> \
                                    </div> \
                                  </div> \
                                    <p>`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.SPEED+`</p> \
                                    <div class="speed-container" id="speed-container"> \
                                        <span id="slow-speed" class="speedometer" qid="aud-8">`+ options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.SLOW + `</span> \
                                        <span id="normal-speed" class="speedometer" qid="aud-10">`+ options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.NORMAL + `</span> \
                                        <span id="fast-speed" class="speedometer" qid="aud-11">`+ options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.FAST+`</span> \
                                    </div> \
                                    <div class="arrow-down"></div> \
                                </div> \
                            </div> \
                        </div> \
                        <button qid="aud-20" class="plyr__control" id="enter-fullscreen-audio-lg" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.ENTER_FULLSCREEN+`">\
                            <img src="assets/img/Full_screen_icon.svg"> \
                        </button>\
                        <button qid="aud-20" class="plyr__control" id="exit-fullscreen-audio-lg" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.EXIT_FULLSCREEN+`">\
                            <img src="assets/img/Shrink_black.svg"> \
                        </button>\
                    </div> \
                </div> \
            </div>`
        ;

        var audioSource = options.basepath+"/"+options.jsonData[options.jsonData.type].path; 
        audioSource = audioSource.replace(/ /g, '%20');

        var captionsSource;
        if(options.jsonData.type == 'audio-package') {
            captionsSource = options.basepath+"/"+options.jsonData[options.jsonData.type].subtitles; 
            captionsSource = captionsSource.replace(/ /g, '%20');
        }

        var audioHTML1 = ` \
            <div class="audio-overlay-container"> \
                <div class="audio-container"> \
                    <div class="titlebar"> \
                        <div class="draggable"> \
                            <button qid="aud-16" class="plyr__control drag_control" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.DRAG+`">\
                                <span class="drag-icon"></span> \
                            </button> \
                        </div> \
                        <div class="closediv"> \
                            <button qid="aud-17" class="plyr__control" id="close" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.CLOSE+`">\
                                <i class="nemo-font nemo-cross"></i> \
                            </button>\
                        </div> \
                    </div> \
                    <div class="title-section dragger"> \
                        <div id="dragFullscreenDiv"> \
                            <button qid="aud-22" class="plyr__control dragger" id="horizontalDrag" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.DRAG+`">\
                                <img src="assets/img/Horizontal_Drag.svg"> \
                            </button>\
                            <button qid="aud-20" class="plyr__control" id="exit-fullscreen-audio-mobile" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.EXIT_FULLSCREEN+`">\
                                <img src="assets/img/Shrink_black.svg"> \
                            </button>\
                        </div> \
                        <button qid="aud-17" class="plyr__control" id="close-in-title" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.CLOSE+`">\
                            <i class="nemo-font nemo-cross"></i> \
                        </button>\
                    </div> \
                    <div class="subtitle-section"> \
                        <div class="subtitle-container" id="subtitle-container"> \
                            <p id="subtitle" class="m-0"></p> \
                        </div> \
                    </div> \
                    <div class="transcript-section"> \
                        <div class="transcriptSuperContainer"> \
                            <div class="transcript-container" id="transcript-container"> \
                                <div id="transcript"></div> \
                            </div> \
                        </div> \
                    </div> \
                    <div class="audioplayer-component"> \
                        <audio id="audio-player" controls crossorigin="anonymous"> \
                            <source src=`+audioSource+` type="audio/mp3" />`;
            let audioHTML2 =`</audio> \
                    </div> \
                    <div class="footer-section"> \
                        <div class="bottom-right-resizer"> \
                            <button qid="aud-23" class="resizable-btn" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.RESIZE+`">\
                                <img src="assets/img/resize-black-new.svg"> \
                            </button> \
                        </div> \
                    </div> \
                </div> \
            </div>`
        ;

        let audioHTML;
        if(captionsSource) {
            let capHTML = `<track kind="subtitles" label="English subtitles" src="`+captionsSource+`" srclang="en" default></track>`;
            audioHTML = audioHTML1 + capHTML + audioHTML2;
        } else {
            audioHTML = audioHTML1 + audioHTML2;
        }

        var overlayContainer = document.querySelector('.overlay-container');
        overlayContainer.classList.add('mobile-audio-player');
        var contentContainer = document.querySelector('.content-container');

        overlayContainer.innerHTML = audioHTML;

        var audioOverlayContainer = document.querySelector('.audio-overlay-container');
        var audioContainer = document.querySelector('.audio-container');
        const player = new Plyr('#audio-player', {seekTime:5 , controls:controls, disableContextMenu:false });
        const audioSpeed = document.getElementById("audio-player");
        const transcript = document.getElementById("audio-player");
        var toggleSettings = document.querySelector(".setting");
        var settingContainer = document.getElementById("setting-container");
        var slowSpeedButton = document.getElementById("slow-speed");
        var normalSpeedButton = document.getElementById("normal-speed");
        var fastSpeedButton = document.getElementById("fast-speed");
        var closePlayer = document.querySelector('#close');
        var closeMobilePlayer = document.querySelector('#close-mobile');
        var closeMobileTitleBar = document.querySelector('#close-in-title');
        var showSettings = false;
        var volRange;
        var timeAtLaunch = Date.now();

        var enterFullscreenAudioMobile = document.querySelector('#enter-fullscreen-audio-mobile');
        var exitFullscreenAudioMobile = document.querySelector('#exit-fullscreen-audio-mobile');
        var enterFullscreenAudioLg = document.querySelector('#enter-fullscreen-audio-lg');
        var exitFullscreenAudioLg = document.querySelector('#exit-fullscreen-audio-lg');
        var titleSection = document.querySelector('.title-section');
        var prgrs = document.querySelector('.prgrs');
        var ctrlsMain = document.querySelector('.ctrls-main');
        var ctrls = document.querySelector('.ctrls');

        var subtitleContainer = document.getElementById("subtitle-container");
        var toggleCaptions = document.querySelector(".subs");
        var transcriptBtn = document.querySelector("#transcriptBtn");
        var transcriptSection = document.querySelector('.transcript-section');
        var transcriptContainer = document.getElementById("transcript-container");
        var transcriptDiv = document.getElementById('transcript');
        var subtitle = document.getElementById('subtitle');
        var playPauseButton1 = document.querySelector('#playPauseButton1');
        var playPauseButton2 = document.querySelector('#playPauseButton2');
        var audioPlayerContainer = document.querySelector('.audioplayer-component');
        var subtitleSection = document.querySelector('.subtitle-section');
        var footerSection = document.querySelector('.footer-section');
        var toolbarWrapper = document.querySelector('.toolbar-wrapper');
        var volumeControlContainer = document.querySelector('.volume-control-container');
        subtitleContainer.style.display = 'none';  
        transcriptContainer.style.display = "none";
        transcriptSection.style.display = "none";
        var isSeeking = false;
        var subtitleEndTime = undefined;
        var subtitleStartTime = undefined;        
        var showSubs = false;
        var selectedSpeed = 1;
        var speedMap = {
            slow: 0.75,
            normal: 1,
            fast: 1.25
        }
        var isTranscriptInitialized = false;
        var wasDragged = false;
        var wasResized = false;
        var isMaximizedPlayer = false;
        var orientationChangeCausedResize = false;
        var transcriptContainerMaxHeightBeforeFullscreen = '0px';

        // Toolbar calculated height for adjusting subtitle and transcript
        let toolbarHeight = toolbarWrapper && toolbarWrapper.offsetHeight;
        
        // RegEx to check the expression <hh:mm:ss.sss> in karaoke
        const REforTimestamp = /(<[0-9]{0,2}?:?[0-9]{0,2}:[0-9]{0,2}.?[0-9]{0,3}?>)/;
        const REforHTMLTags = /<\/?([a-z]+) ?[^>]*>/ig;
        const AllowedTags = {
            'b' : 'b',
            'i' : 'i',
            'u' : 'u',
            'span' : 'span',
            'li' : 'li',
            'strong': 'strong'
        }
        
        var timestampObject = {};
        var currentCue = {};
        var cueArray = [];

        if(options.events.onOpen) {
            options.events.onOpen();
        }
        const position = { x: 0, y: 0 };

        dlsAudioPlayer.options = options;

        // added dragger class to the whole audio container as per CUP requirements, and disabled the drag functionality from the prgrs class.
        // as of now, no user is not allowed to drag the audio player when in mobile-view, hence we have removed the dragger class when the user enters full-screen in mobile-view.
        interact('.audio-container').draggable({
            allowFrom: ".dragger",
            restrict: {
                restriction: '.overlay-container',
                elementRect: {top: 0, left: 0, bottom: 1, right: 1}
            },
            ignoreFrom: '#close-in-title'
        }).on('dragstart', function (event) {
            if(options.events.onDragStart) {
                options.events.onDragStart();
            }
            wasDragged = true;
        }).on('dragmove', function (event) {
            position.x += event.dx;
            position.y += event.dy;

            position.x = Math.round(position.x);
            position.y = Math.round(position.y);
            event.target.style.transform = "translate("+position.x+"px, "+position.y+"px)";
        }).resizable({
            edges: {
                bottom: ['.bottom-right-resizer'],
                right: ['.bottom-right-resizer']
            },
            listeners: {
                move(event) {
                    wasResized = true;
                    enterFullscreenAudioLg.classList.add('enter-resized-view');

                    // adding flex properties when the player is not resized
                    if(showSubs && (event.rect.height <= 300 || event.rect.width <= 428)) {
                        enterFullscreenAudioLg.classList.remove('enter-resized-view');
                        return null;
                    } else {
                        enterFullscreenAudioLg.classList.add('enter-resized-view');
                    }

                    // adding flex properties when the player is not resized
                    if(showtrans && (event.rect.height <= 360 || event.rect.width <= 428)) {
                        enterFullscreenAudioLg.classList.remove('enter-resized-view');
                        return null;
                    } else {
                        enterFullscreenAudioLg.classList.add('enter-resized-view');
                    }

                    var target = event.target;

                    // update the element's style
                    target.style.width = event.rect.width + "px";
                    target.style.height = event.rect.height + "px";

                    // adding flex properties when the player is not resized
                    if(event.rect.height <= 168 || event.rect.width <= 428) {
                        target.style.height = "168px";
                        enterFullscreenAudioLg.classList.remove('enter-resized-view');
                    }  else {
                        enterFullscreenAudioLg.classList.add('enter-resized-view');
                    }
                    
                    transcriptContainer.style.maxHeight = audioContainer.clientHeight - 200 + "px";
                    
                    // set font size dynamically
                    setSliderBackground();
                    setDynamicFontSize();

                    // commenting as of now - audio player enters full screen when it touches one of the edges
                    // if(event.rect.width >= (window.innerWidth - 8) || event.rect.height >= (window.innerHeight- 64 - 8)){
                    //     enterFullscreenAudioLg.click();
                    // }
                }
            },
            modifiers: [
                // hardcoding min size as it was getting reset for each iframe mouseup issue fix
                interact.modifiers.restrictSize({
                    min: { width: 428, height: 168 },
                }),
                interact.modifiers.restrictEdges({
                    outer: '.overlay-container'
                }),
                interact.modifiers.aspectRatio({
                    ratio: 'preserve',
                    modifiers: [
                        interact.modifiers.restrictEdges({
                            outer: '.overlay-container'
                        })
                    ]
                })
            ],
            inertia: true
        });

        positionAudioPlayer();


        var browser = {
            isIE: !!document.documentMode,
            isEdge: window.navigator.userAgent.includes('Edge'),
            isWebkit: 'WebkitAppearance' in document.documentElement.style && !/Edge/.test(navigator.userAgent),
            isIPhone: /(iPhone|iPod)/gi.test(navigator.platform),
            isIos: /(iPad|iPhone|iPod)/gi.test(navigator.platform)
        };

        if(browser.isIPhone === true || browser.isIos === true){
            volumeControlContainer.style.display = "none";
        }


        if (browser.isIE && window.URL) {
            var elements = document.querySelectorAll("track");
            Array.from(elements).forEach(function (track) {
                var src = track.getAttribute('src');
                var url = parseUrl(src);

                if (url !== null && url.hostname !== window.location.href.hostname && ['http:', 'https:'].includes(url.protocol)) {
                    fetchFile(src, 'blob').then(function (blob) {
                        track.setAttribute('src', window.URL.createObjectURL(blob));
                    }).catch(function () {
                        // TODO
                    });
                }
            });
        }
        
        function parseUrl(input) {
            var safe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var url = input;
        
            if (safe) {
              var parser = document.createElement('a');
              parser.href = url;
              url = parser.href;
            }
        
            try {
              return new URL(url);
            } catch (e) {
              return null;
            }
        } 
        
        // Will be used to fetch vtt file in IE
        function fetchFile(url) {
            var responseType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'text';
            return new Promise(function (resolve, reject) {
              try {
                var request = new XMLHttpRequest(); // Check for CORS support
                if (!('withCredentials' in request)) {
                  return;
                }
        
                request.addEventListener('load', function () {
                  if (responseType === 'text') {
                    try {
                      resolve(JSON.parse(request.responseText));
                    } catch (e) {
                      resolve(request.responseText);
                    }
                  } else {
                    resolve(request.response);
                  }
                });
                request.addEventListener('error', function () {
                  throw new Error(request.status);
                });
                request.open('GET', url, true); // Set the required response type
        
                request.responseType = responseType;
                request.send();
              } catch (e) {
                reject(e);
              }
            });
        }
        
        // looop configuration object, which tells current state of loop
        var loopConfig =  {
            "active" : false, // boolean to show if loop is active or not
            "startPoint" : undefined, // shows the start point of loop (in fraction)
            "endPoint" : undefined // shows the end point of loop (in fraction)
        };
        var loopButton = document.getElementsByClassName("loop-button")[0];
        loopButton.addEventListener("click", function() {
            // total width of slider background
            var totalWidth = document.getElementsByClassName("plyr__progress")[0].clientWidth;
            if(!loopConfig.active) {
                if((loopConfig.startPoint==0 || loopConfig.startPoint) && !loopConfig.endPoint){
                    var endPoint = parseInt((player.currentTime/player.duration)*10000)/10000;                    
                    // NEMO issue (NEMO-2857) : Start and end of audio loop cannot be on the same audio position
                    if(parseInt(endPoint*player.duration) - parseInt(loopConfig.startPoint*player.duration) >= 1) {
                        loopConfig.active = true;
                        loopConfig.endPoint = parseInt((player.currentTime/player.duration)*10000)/10000;
                        player.currentTime = loopConfig.startPoint * player.duration;                 
                        
                        //end flag ON
                        let endFlag = document.getElementsByClassName("end-flag")[0];
                        endFlag.style.display = "block";
                        endFlag.style.left = loopConfig.endPoint*totalWidth + "px";
    
                        // tooltip message
                        loopButton.setAttribute('title', options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.EXIT_LOOP);
                        document.getElementById("loop-glyph").style.opacity = 1;                        
                    }
                
                } else if(!loopConfig.startPoint) {
                    // NEMO issue (NEMO-2857) : Start and end of audio loop cannot be on the same audio position (handling of video end part)                    
                    if(parseInt(player.duration) -  parseInt(player.currentTime) >= 1) {
                        loopConfig.startPoint = parseInt((player.currentTime/player.duration)*10000)/10000; 
                        loopConfig.endPoint = undefined;
    
                        // start flag ON
                        let startFlag = document.getElementsByClassName("start-flag")[0];
                        startFlag.style.display = "block";
                        startFlag.style.left = loopConfig.startPoint*totalWidth + "px";
    
                        // tooltip message
                        loopButton.setAttribute('title', options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.END_LOOP);
                        document.getElementById("loop-glyph").style.opacity = 0.5;
                    }
                    
                }                
            } else {

                loopConfig.active = false;
                loopConfig.startPoint = undefined;
                loopConfig.endPoint = undefined;

                // hide start and end flag if loop is not active
                let startFlag = document.getElementsByClassName("start-flag")[0];
                let endFlag = document.getElementsByClassName("end-flag")[0];
                startFlag.style.display = "none";
                endFlag.style.display = "none";
                
                // tooltip message
                loopButton.setAttribute('title', options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.START_LOOP);
           
            }

            // update slider background progress colors and gradient colors (if looping is enabled) 
            setSliderBackground();
        });

        // update slider background progress colors and gradient colors (if looping is enabled)    
        function setSliderBackground() {
            // total width of slider
            var totalWidth = document.getElementsByClassName("plyr__progress")[0].clientWidth;
            // plyr progress in fraction
            var playerProgress = (player.duration==0 ? 0 : player.currentTime/player.duration);
            // progress background (purple and white)
            var progressBackground = document.getElementById("progress-background");
            // left gradient of loop
            var gradientBackgroundLeft = document.getElementById("gradient-background-left");
            // right gradient of loop
            var gradientBackgroundRight = document.getElementById("gradient-background-right");
            
            if(loopConfig.active) {
                var startPoint = loopConfig.startPoint;
                var endPoint = loopConfig.endPoint;

                // NEMO 14038: set flags possition when setting slider for audio progress
                setFlagsPosition();

                playerProgress = playerProgress < startPoint ? startPoint : playerProgress;
                // if loop is active show left and right gradient
                gradientBackgroundLeft.style.display = "block";
                gradientBackgroundRight.style.display = "block";
                // gradient dynamic styles 
                gradientBackgroundRight.style.width = (endPoint-startPoint)*totalWidth + "px";                                       
                gradientBackgroundLeft.style.left = startPoint*totalWidth + "px";
                gradientBackgroundRight.style.left = (startPoint*totalWidth+13) + "px";
                
            } else if(loopConfig.startPoint !== undefined) {
                let startFlag = document.getElementsByClassName("start-flag")[0];
                startFlag.style.display = "block";
                startFlag.style.left = loopConfig.startPoint*totalWidth + "px"
            } else {
                // hide gradient background if loop is not active
                gradientBackgroundLeft.style.display = "none"; 
                gradientBackgroundRight.style.display = "none";                    
            }
            
            // dynamic styles of progress background and  gradient background
            gradientBackgroundLeft.style.width = ((playerProgress - startPoint)*totalWidth + 6.5) + "px";
            progressBackground.style.width = totalWidth + "px";
            progressBackground.style.backgroundSize = (playerProgress*totalWidth+6.5) + "px 5px, " + ((1-playerProgress)*totalWidth+13) + "px 5px";
            progressBackground.style.backgroundPosition = "0px, " + (playerProgress*totalWidth+6.5) + "px";
                
        }

        function setFlagsPosition(){
            var totalWidth = document.getElementsByClassName("plyr__progress")[0].clientWidth;

            let startFlag = document.getElementsByClassName("start-flag")[0];
            startFlag.style.display = "block";
            startFlag.style.left = loopConfig.startPoint*totalWidth + "px";

            let endFlag = document.getElementsByClassName("end-flag")[0];
            endFlag.style.display = "block";
            endFlag.style.left = loopConfig.endPoint*totalWidth + "px";

        }

        var forward = document.querySelector("#forward");
        var rewind = document.querySelector("#rewind");
        rewind.classList.add("disabled");
        
        forward.addEventListener("click", function() {
            if(!forward.classList.contains('disabled')) {
                player.forward(5);
            }
        });
        rewind.addEventListener("click", function() {
            if(!rewind.classList.contains('disabled')) {
                player.rewind(5);
            }
        });

        audioSpeed.addEventListener("play", function () {
            changeSpeed(selectedSpeed);
        });

        toggleSettings.addEventListener("click", function() {
            showSettings = !showSettings;
            if (showSettings) {
                settingContainer.style.display = "block";
                volRange = new RangeTouch('input[data-plyr="volume"]');
                $(".selected-speed").removeClass("selected-speed");
                if (selectedSpeed === speedMap.slow) {
                    slowSpeedButton.classList.add("selected-speed");
                } else if (selectedSpeed === speedMap.normal) {
                    normalSpeedButton.classList.add("selected-speed");
                } else {
                    fastSpeedButton.classList.add("selected-speed");
                }
            } else {
                settingContainer.style.display = "none";
            }
        });
        
        slowSpeedButton.addEventListener("click", function() {
            selectedSpeed = speedMap.slow;
            changeSpeed(selectedSpeed);
            $(".selected-speed").removeClass("selected-speed");
            $("#slow-speed").addClass("selected-speed");
        });

        normalSpeedButton.addEventListener("click", function() {
            selectedSpeed = speedMap.normal;
            changeSpeed(selectedSpeed);
            $(".selected-speed").removeClass("selected-speed");
            $("#normal-speed").addClass("selected-speed");
        });

        fastSpeedButton.addEventListener("click", function() {
            selectedSpeed = speedMap.fast;
            changeSpeed(selectedSpeed);
            $(".selected-speed").removeClass("selected-speed");
            $("#fast-speed").addClass("selected-speed");
        });

        function changeSpeed(value) {
            audioSpeed.playbackRate = value;
        }
        player.on('timeupdate', function(){

            var currentTime = parseInt(player.currentTime);
            var duration = parseInt(player.duration);

            //karoake subtitles
            if(currentCue.timeStamp) {
                var currentIndex = 0;
                for(let i=0; i<timestampObject[currentCue.id].length; i++) {
                    var karaokeTime = timestampObject[currentCue.id][i];
                    if(player.currentTime >= karaokeTime) {
                        if(i < timestampObject[currentCue.id].length - 1) {
                            if(player.currentTime >= timestampObject[currentCue.id][i+1]) continue;
                            else {
                                currentIndex = (i+1);
                                break;
                            }
                        } else {
                            currentIndex = timestampObject[currentCue.id].length;
                        }
                    }
                }

                var elSubtitles = document.querySelectorAll("#subtitle > span");
                for(let i=0; i< elSubtitles.length; i++) {
                    elSubtitles[i].classList.remove('current-karoake');
                    elSubtitles[i].classList.remove('future-karoake');
                    elSubtitles[i].classList.remove('past-karoake');
                    if(i > currentIndex) {
                        elSubtitles[i].classList.add('future-karoake');
                    } else if (i < currentIndex) {
                        elSubtitles[i].classList.add('past-karoake');
                    } else {
                        elSubtitles[i].classList.add('current-karoake');
                    }
                }
            }
            
            // rewind disable handling
            if(currentTime == 0) {
                rewind.classList.add("disabled");
            } else {
                rewind.classList.remove("disabled");                
            }

            // forward disable handling
            if(currentTime == duration) {
                forward.classList.add("disabled");
            } else {
                forward.classList.remove("disabled");                
            }

            if(showSubs && !isSeeking) {
                if((subtitleEndTime && player.currentTime > subtitleEndTime) || (subtitleStartTime && player.currentTime < subtitleStartTime)) {
                    subtitleEndTime = undefined;
                    subtitleStartTime  = undefined;
                    subtitle.innerText = '';                      
 
                }
            }

            if(loopConfig.active) {
                let progress = parseInt((player.currentTime/player.duration)*100);
                var loopEndPoint = parseInt(loopConfig.endPoint*100);
                var loopStartPoint = parseInt(loopConfig.startPoint*100);
                
                if(loopEndPoint==0 || (loopEndPoint && progress >= loopEndPoint) || progress < loopStartPoint) {
                    var difference = (loopStartPoint-progress) > 1 ? true : false;
                    if(difference) {
                        player.currentTime = parseInt((loopConfig.startPoint)*player.duration*100)/100;
                    }
                    if((loopEndPoint || loopEndPoint==0) && progress >= loopEndPoint)  {
                        player.currentTime = parseInt((loopConfig.startPoint)*player.duration*100)/100;
                        
                    }                  
                    
                }
            }
            
            if(loopConfig.startPoint || parseInt(loopConfig.startPoint*player.duration)==0 ) {
                let progress = parseInt((player.currentTime/player.duration)*100);
                var loopStart = parseInt(loopConfig.startPoint*100);
                if(loopStart - progress > 1) {
                    player.currentTime = parseInt((loopConfig.startPoint)*player.duration*100)/100; 
                }

                if(!loopConfig.endPoint) {
                    var endPoint = parseInt((player.currentTime/player.duration)*10000)/10000;                    
                    if(parseInt(endPoint*player.duration) - parseInt(loopConfig.startPoint*player.duration) < 1) {
                        document.getElementById("loop-glyph").style.opacity = 0.5;                        
                    } else {
                        document.getElementById("loop-glyph").style.opacity = 1;                                        
                    }
                }
            }
            
            setSliderBackground();
        });

        player.on('play', function() {
            playPauseButton1.setAttribute('title', options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.PAUSE);
            playPauseButton2.setAttribute('title', options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.PAUSE);
        });

        player.on('pause', function() {
            playPauseButton1.setAttribute('title', options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.PLAY);
            playPauseButton2.setAttribute('title', options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.PLAY);
        });
        
        orientationChangeEventListener = function() {
            
            orientationChangeCausedResize = true;

            setDynamicFontSize();
            positionAudioPlayer();

            position.x = 0;
            position.y = Math.round(position.y);
            position.x = Math.round(position.x);
            audioContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";

        }
        window.addEventListener("orientationchange", orientationChangeEventListener);

        enterFullscreenAudioMobile.addEventListener('click', function() {
            enterFullScreenCommonHandler(true);
        });

        enterFullscreenAudioLg.addEventListener('click', function() {
            enterFullScreenCommonHandler(false);
        });

        function enterFullScreenCommonHandler(isMobile = false){
            isMaximizedPlayer = true;
            titleSection.classList.add('mobile-fullscreen-entered');
            prgrs.classList.add('mobile-fullscreen-entered');
            audioContainer.classList.add('mobile-fullscreen-entered');
            ctrlsMain.classList.add('mobile-fullscreen-entered');
            ctrls.classList.add('mobile-fullscreen-entered');
            overlayContainer.classList.add('mobile-fullscreen-entered');
            audioPlayerContainer.classList.add('mobile-fullscreen-entered');
            subtitleSection.classList.add('mobile-fullscreen-entered');
            transcriptContainer.classList.add('mobile-fullscreen-entered');
            audioOverlayContainer.classList.add('mobile-fullscreen-entered');
            footerSection.classList.add('mobile-fullscreen-entered');
            enterFullscreenAudioLg.classList.add('mobile-fullscreen-entered');
            exitFullscreenAudioLg.classList.add('mobile-fullscreen-entered');
            titleSection.classList.remove('dragger');
            var progressBackground = document.getElementById("progress-background");
            progressBackground.style.width = document.querySelector('.audio-progress-bar').clientWidth + "px";
            transcriptContainerMaxHeightBeforeFullscreen = transcriptContainer.style.maxHeight;
            transcriptContainer.style.maxHeight = audioContainer.clientHeight - 228 + "px";
           
            //hiding side bar
            let sidebar = document.querySelector('.sidebar') || document.querySelector('.notes-wrapper')|| document.querySelector('.dictionary-wrapper');
     
            if(sidebar && ( sidebar.classList.contains('notes-left') || sidebar.classList.contains('toc-left') ||  sidebar.classList.contains('dictionary-left') ) ) {
                overlayContainer.classList.add('sidebar-open-left');
            } else if( sidebar && ( sidebar.classList.contains('notes-right') || sidebar.classList.contains('toc-right') ||  sidebar.classList.contains('dictionary-right')) ) {
                overlayContainer.classList.add('sidebar-open-right');
            }

            // set font size dynamically
            setDynamicFontSize();
            // set background colour and gradient color if loop is active
            setSliderBackground();
            centerAudioPlayerIfOutOfBoundsWhileDrag();

            if(!isMobile){
                positionAudioPlayer();
                if(!showSubs && !showtrans) {
                    toggleSubtitles();
                }
            } else if(!wasDragged) {
                positionAudioPlayer();
            }
        }

        function closeAudioSettingsHandler(event){
            var clickedInsideAudioPlayer = settingContainer.contains(event.target);
                if (!clickedInsideAudioPlayer) {
                    showSettings = true;
                    toggleSettings.click();
                }
        }

        function keyboardEventHandler(event){
            if(event.keyCode === 27){
                if(window.innerWidth <= 576){
                    isMaximizedPlayer && exitFullScreenCommonHandler(true)
                } else {
                    isMaximizedPlayer && exitFullScreenCommonHandler(false);
                }
                showSettings = true;
                toggleSettings.click();
            }
        }

        document.addEventListener('keydown',(event)=> {
            keyboardEventHandler(event);
        });
        
        document.addEventListener('click', function(event){
            closeAudioSettingsHandler(event);
        })
        
        exitFullscreenAudioMobile.addEventListener('click', function() {
            exitFullScreenCommonHandler(true);
        });

        exitFullscreenAudioLg.addEventListener('click', function() {
            exitFullScreenCommonHandler(false);
        });

        function exitFullScreenCommonHandler(isMobile = false) {
            isMaximizedPlayer = false;
            titleSection.classList.remove('mobile-fullscreen-entered');
            prgrs.classList.remove('mobile-fullscreen-entered');
            audioContainer.classList.remove('mobile-fullscreen-entered');
            ctrlsMain.classList.remove('mobile-fullscreen-entered');
            ctrls.classList.remove('mobile-fullscreen-entered');
            overlayContainer.classList.remove('mobile-fullscreen-entered');
            overlayContainer.classList.remove('sidebar-open-left');
            overlayContainer.classList.remove('sidebar-open-right');
            audioPlayerContainer.classList.remove('mobile-fullscreen-entered');
            subtitleSection.classList.remove('mobile-fullscreen-entered');
            transcriptContainer.classList.remove('mobile-fullscreen-entered');
            audioOverlayContainer.classList.remove('mobile-fullscreen-entered');
            footerSection.classList.remove('mobile-fullscreen-entered');
            enterFullscreenAudioLg.classList.remove('mobile-fullscreen-entered');
            exitFullscreenAudioLg.classList.remove('mobile-fullscreen-entered');
            var progressBackground = document.getElementById("progress-background");
            progressBackground.style.width = document.querySelector('.audio-progress-bar').clientWidth + "px";
            if(audioContainer.clientHeight < 300){
                audioContainer.style.height = 'auto';
            }
            if(audioContainer.clientHeight > 228){
                transcriptContainer.style.maxHeight = transcriptContainerMaxHeightBeforeFullscreen;
            } else {
                transcriptContainer.style.maxHeight = "184px";
            }
            // set font size dynamically
            setDynamicFontSize();
            // set background colour and gradient color if loop is active
            setSliderBackground();
            centerAudioPlayerIfOutOfBoundsWhileDrag();

            if (isMobile) {
                if(showtrans) {
                    toggleTranscripts();
                }

                if(showSubs) {
                    toggleSubtitles();
                }
            }
            if(!isMobile){
                titleSection.classList.add('dragger');
                positionAudioPlayer();
            } else if(!wasDragged) {
                positionAudioPlayer();
            }
        }

        function centerAudioPlayerIfOutOfBoundsWhileDrag() {
            let sidebar = document.querySelector('.sidebar') || document.querySelector('.notes-wrapper')|| document.querySelector('.dictionary-wrapper');
     
            if(overlayContainer.style.display == 'none') {
                return;
            }

            if(audioContainer.style.transform && audioContainer.getBoundingClientRect().left < contentContainer.getBoundingClientRect().left) {
                //if Fullscreen mode is active and we are on left with active toolbar to avoid toolbar visiblity issue during resizing 
                if (isMaximizedPlayer && (sidebar && ( sidebar.classList.contains('notes-left') || sidebar.classList.contains('toc-left') ||  sidebar.classList.contains('dictionary-left') ) )) {
                  position.x = audioContainer.offsetWidth / 2;
                } else {
                  position.x = position.x -(audioContainer.getBoundingClientRect().left - contentContainer.getBoundingClientRect().left);
                }
                
                position.x = Math.round(position.x);
                position.y = Math.round(position.y);
                audioContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
            } else if(audioContainer.style.transform && audioContainer.getBoundingClientRect().left + audioContainer.getBoundingClientRect().width > contentContainer.getBoundingClientRect().right) {
                position.x = position.x - (audioContainer.getBoundingClientRect().left + audioContainer.getBoundingClientRect().width - contentContainer.getBoundingClientRect().right);

                //if Fullscreen mode is active and we are on right with active toolbar to avoid toolbar visiblity issue during resizing it
                if(($(window).width() > 576) && isMaximizedPlayer && (sidebar && (sidebar.classList.contains('notes-right') || sidebar.classList.contains('toc-right') || sidebar.classList.contains('dictionary-right')))){
                    position.x += 320 ;//Adding width of Toc 
                }
                position.y = Math.round(position.y);
                position.x = Math.round(position.x);
                audioContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
            }

            if(audioContainer.style.transform && audioContainer.getBoundingClientRect().top < contentContainer.getBoundingClientRect().top) {
                position.y = position.y - audioContainer.getBoundingClientRect().top + contentContainer.getBoundingClientRect().top;

                position.x = Math.round(position.x);
                position.y = Math.round(position.y);
                audioContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
            } else if(audioContainer.style.transform && audioContainer.getBoundingClientRect().top + audioContainer.getBoundingClientRect().height > contentContainer.getBoundingClientRect().height + contentContainer.getBoundingClientRect().top) {
                position.y = position.y - (audioContainer.getBoundingClientRect().top + audioContainer.getBoundingClientRect().height - (contentContainer.getBoundingClientRect().height + contentContainer.getBoundingClientRect().top));
            
                position.y = Math.round(position.y);
                position.x = Math.round(position.x);
                audioContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
            }



        }

        
    /************************************************************************************************* */
    /********************************Audio Subtitle and Transcripts Start **************************** */
    /************************************************************************************************* */
        
        player.on('seeking', function(){
            isSeeking = true;
            setSliderBackground();
        });
        player.on('seeked', function() {
            isSeeking = false;
        });

        if(options.jsonData.type != "audio") {
            toggleCaptions.addEventListener ( 'click' , function () {
                toggleSubtitles();
            });
        }

        function toggleSubtitles() {

            if(showtrans) {
                toggleTranscripts();
            }

            let subtitleButton = document.getElementById("subtitle-button");

            if(subtitleButton.classList.contains("disabled")){
                return;
            }

            showSubs = !showSubs;
            if (showSubs) {
                subtitleButton.classList.add('active');
                toggleCaptions.setAttribute('title', options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.DISABLE_SUBTITLES);
                subtitleContainer.style.display = 'flex';
                if(audioContainer.offsetHeight <= 300 && window.innerWidth > 576 && wasResized){
                    audioContainer.style.height = "300px";
                }
                //set font size dynamically
                setDynamicFontSize();
                // NEMO-4870 : [eReader] Audio player is not fully visible when changing player size while positioned at the edge of the screen
                if(audioContainer.style.transform && audioContainer.getBoundingClientRect().top < contentContainer.getBoundingClientRect().top) {
                    position.y = position.y - audioContainer.getBoundingClientRect().top + contentContainer.getBoundingClientRect().top - toolbarHeight;
                    position.x = Math.round(position.x);
                    position.y = Math.round(position.y);
                    audioContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
                } else if(audioContainer.style.transform && audioContainer.getBoundingClientRect().top + audioContainer.getBoundingClientRect().height > contentContainer.getBoundingClientRect().height + contentContainer.getBoundingClientRect().top) {
                    position.y = position.y - (audioContainer.getBoundingClientRect().top + audioContainer.getBoundingClientRect().height - toolbarHeight - (contentContainer.getBoundingClientRect().height + contentContainer.getBoundingClientRect().top));
                    position.y =Math.round(position.y);
                    position.x = Math.round(position.x);
                    audioContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
                }

                // NEMO-14257 [eReader] Audio player widget's controls are blocked from view when opening the subtitle/transcripts
                if(!isMaximizedPlayer){
                    centerAudioPlayerIfOutOfBoundsWhileDrag();
                }
            } else {
                subtitleButton.classList.remove('active');
                toggleCaptions.setAttribute('title', options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.ENABLE_SUBTITLES);
                subtitle.innerText = '';
                subtitleContainer.style.display = 'none';
            }
        }

        document.getElementById('audio-player').textTracks[0]?.addEventListener('cuechange', function() {

            if(!(document.getElementById('audio-player') && dlsAudioPlayer.player)){
                return;
            }

            for(let i=0; i<this.cues.length; i++) { // removing active cue everytime
                let elem = document.getElementById(this.cues[i].id);
                if(elem && this.activeCues[0] !== undefined && this.activeCues[0].timeStampValue !== undefined) {
                    if(this.cues[i].timeStampValue < this.activeCues[0].timeStampValue) {
                        elem.classList.remove('current');
                        elem.classList.remove('future');
                        elem.classList.add('past');
                    } else if(this.cues[i].timeStampValue > this.activeCues[0].timeStampValue) {
                        elem.classList.remove('current');
                        elem.classList.remove('past');
                        elem.classList.add('future');
                    } else {
                        elem.classList.remove('future');
                        elem.classList.remove('past');
                        elem.classList.add('current');
                    }
                }
            }
            
            if(this.activeCues && this.activeCues.length && this.activeCues[0] && this.activeCues[0].text) {
                currentCue = this.activeCues[0];
                // subtitleContainer.style.backgroundColor = "#FFFFFF";

                var subText = '';

                for(let i=0; i<Object.keys(cueArray).length; i++) {
                    if(this.activeCues[0].id === Object.keys(cueArray)[i]) {
                        subText = cueArray[Object.keys(cueArray)[i]];
                    }
                }
                var text = addSpan(subText);
                text = text.replace(REforHTMLTags, function (wholeMatch, tagName) {
                    if (AllowedTags[tagName.toLowerCase()]) {
                        return wholeMatch;
                    } else {
                        return "";
                    }
                });
                subtitle.innerHTML = text;
                subtitleEndTime = this.activeCues[0].endTime;
                subtitleStartTime = this.activeCues[0].startTime;
                currentCue = this.activeCues[0];
                var transcriptText = document.getElementById(this.activeCues[0].id);
                // scroll to a position such that active transcript is not excatly at to top but second or third.
                if(window.innerHeight < 576) {
                    transcriptContainer.scrollTop = transcriptText.offsetTop;
                } else {
                    transcriptContainer.scrollTop = transcriptText.offsetTop - 60;
                }
                transcriptText.classList.add("current");
            }
            
            setTranscriptCueOpacity();
            setDynamicFontSize();

        });

        var showtrans = false;
        let tracks, trackElems;
        trackElems = document.querySelectorAll("track");
        tracks = transcript.textTracks;
        if(!isTranscriptInitialized) initTranscript(tracks);

        
        transcriptBtn.addEventListener("click", function() {
            toggleTranscripts()
        });

        function initTranscript(tracks2) {
            let lang = "en";
            // Locate the track with language = lang
            for(let i = 0; i < tracks2.length; i++) {
                // current track
                var track = tracks2[i];
                var trackAsHtmlElem = trackElems[i];
            
                if((track.language === lang) && (track.kind !== "chapters")) {
                    track.mode="showing";
                
                    if(trackAsHtmlElem.readyState === 2) {
                        // the track has already been loaded
                        displayCues(track);
                    } else {
                        displayCuesAfterTrackLoaded(trackAsHtmlElem, track);
                    }
                
                }
            } 
            isTranscriptInitialized = true;
        }

        function toggleTranscripts() {

            if(showSubs) {
                toggleSubtitles();
            }

            let transcriptButton = document.getElementById("transcriptBtn");

            if (transcriptButton.classList.contains('disabled')) {
                return;
            }

            showtrans = !showtrans;

            if(showtrans) {
                transcriptContainer.style.display = "block";
                transcriptSection.style.display = "block";
                transcriptBtn.classList.add('active');
                transcriptBtn.setAttribute('title', options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.DISABLE_TRANSCRIPTS);
                titleSection.classList.add('transcript-open');

                if(audioContainer.offsetHeight <= 360 && window.innerWidth > 576 && wasResized){
                    audioContainer.style.height = "360px";
                }
                //set font size dynamically
                setSliderBackground();
                setDynamicFontSize();

                // NEMO-4870 : [eReader] Audio player is not fully visible when changing player size while positioned at the edge of the screen
                if(audioContainer.style.transform && audioContainer.getBoundingClientRect().top < contentContainer.getBoundingClientRect().top) {
                    position.y = position.y - audioContainer.getBoundingClientRect().top + contentContainer.getBoundingClientRect().top - toolbarHeight;

                    position.x = Math.round(position.x);
                    position.y = Math.round(position.y);
                    audioContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
                } else if(audioContainer.style.transform && audioContainer.getBoundingClientRect().top + audioContainer.getBoundingClientRect().height > contentContainer.getBoundingClientRect().height + contentContainer.getBoundingClientRect().top) {
                    position.y = position.y - (audioContainer.getBoundingClientRect().top + audioContainer.getBoundingClientRect().height - toolbarHeight - (contentContainer.getBoundingClientRect().height + contentContainer.getBoundingClientRect().top));
                    
                    position.x = Math.round(position.x);
                    position.y = Math.round(position.y);
                    audioContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
                }
                
                // NEMO-14257 [eReader] Audio player widget's controls are blocked from view when opening the subtitle/transcripts
                if(!isMaximizedPlayer){                    
                    centerAudioPlayerIfOutOfBoundsWhileDrag();
                }
                
                setTranscriptCueOpacity();
            } else {
                transcriptBtn.classList.remove('active');
                transcriptBtn.setAttribute('title', options.translations.FOC._COMMON_ACROSS_PAGES.AUDIO.ENABLE_TRANSCRIPTS);
                transcriptContainer.style.display = "none";
                transcriptSection.style.display = "none";
                transcriptContainer.style.display = "none";
                transcriptSection.style.display = "none";
                titleSection.classList.remove('transcript-open');
            }
        }

        function displayCuesAfterTrackLoaded(trackElem, track) {
            // Create a listener that will be called only when the track has
            // been loaded
            trackElem.addEventListener('load', function(e) {
                displayCues(track);
            });
        }

        function displayCues(track) {
            var cues = track.cues;
            //append all the subtitle texts to 
            for(var i=0, len = cues.length; i < len; i++) {
                var cue = cues[i];
                cue.id = cue.id || "audio-cue-" + i;
                cue.qid = cue.qid || i+1;
                cue.timeStampValue = cue.startTime + 0.2;
                //addCueListeners(cue);

                //to check if the cue is karoake or not
                if(!cue.text.match(REforTimestamp)){
                    cue.timeStamp = false;
                    //html text
                    var transText = "";
                    cueArray[cue.id] = cue.text;
                    transText = cue.text;
                } else {
                    cue.timeStamp = true;
                    //html text and add span
                    var transText = "";
                    cueArray[cue.id] = cue.text;
                    transText = addSpan(cue.text);

                    var timeStampArray = [];
                    timeStampArray = addArray(cue.text);
                    timestampObject[cue.id] = timeStampArray;
                }

                //store information in terms of html
                var regex = /(<([^>]+)>)/ig
                ,   body = cue.text
                ,   resultHTML = body.replace(regex, "");
                
                cue.updatedText = resultHTML;
                
                var clickableTransText = "<li timeStampValue='" + cue.timeStampValue + "' class='cues' qid='aud-cue-" + cue.qid +"' id=" + cue.id +  "  onclick='jumpTo(" + cue.startTime + ");'" + ">" + "<span id='text' class='text'>" + transText + "</span>" + "</li>";
                addToTranscriptDiv(clickableTransText);
                
        
            }
        }

        function addSpan(text) {
            let index = 0;
            let result = "";
            let splitText = text.split(REforTimestamp);
            for (let i = 0; i < splitText.length; i++) {
                if (!splitText[i].match(REforTimestamp)) {
                    result += "<span class=" + index + ">" + splitText[i] + "</span>";
                    index++;
                }
            }
            if (result == "") {
                result = text;
            }
            return result;
        }

        function jumpTo(time) {
            transcript.currentTime = time;
        }

        function addArray(text) {
            let result = [];
            let split = text.split(REforTimestamp);
            for (let i = 0; i < split.length; i++) {
                if (!!split[i].match(REforTimestamp)) {
                    let a = split[i].substring(1, split[i].length - 1);
                    let b = a.split(':');
                    let c = (b[0] * 60 * 60) + (+(b[1] * 60)) + (+b[2]);
                    if (b.length == 2) {
                        c = (+(b[0] * 60)) + (+b[1]);
                    }
                    result.push(c);
                }
            }
            return result;
        }
    
        window.jumpTo = jumpTo;
        
        function addToTranscriptDiv(htmlText) {
            htmlText = htmlText.replace(REforHTMLTags, function (wholeMatch, tagName) {
                if (AllowedTags[tagName.toLowerCase()]) {
                    return wholeMatch;
                } else {
                    return "";
                }
            });
            transcriptDiv.innerHTML += htmlText;
        }


        document.querySelector('#transcript-container').addEventListener('scroll', function(event) {
            setTranscriptCueOpacity();
        });
        
        // function to add dynamic opacity to transcript cues based on current scroll position.
        function setTranscriptCueOpacity() {
            
            if(!document.querySelector('#transcript-container')) {
                return;
            }
            var containerScrT = document.querySelector('#transcript-container').scrollTop
            var containerH = document.querySelector('#transcript-container').offsetHeight
            
            var cues = document.querySelectorAll('.cues');
            cues.forEach(cue => {
                var cueH = cue.offsetHeight
                var cueT = cue.offsetTop
                var visibleSpectrum = containerScrT + containerH;
                var cueStartTop = cueT - cueH;
                var relPosition = visibleSpectrum - cueStartTop;

                cue.setAttribute('position-relative', relPosition);

                if(window.innerHeight >= 632 && window.innerWidth >= 768)  {
                    if(relPosition > 420 || relPosition < 160) {
                        cue.style.opacity = 0.5;
                    } else if(relPosition > 360 || relPosition < 220) {
                        cue.style.opacity = 0.75;
                    } else {
                        cue.style.opacity = 1;
                    }
                } else {
                    if(relPosition > 240 || relPosition < 80) {
                        cue.style.opacity = 0.5;
                    } else if(relPosition > 200 || relPosition < 120) {
                        cue.style.opacity = 0.75;
                    } else {
                        cue.style.opacity = 1;
                    }
                }

                if(cue.classList.contains('current')) {
                    cue.style.opacity = 1;
                }

            });
        }

        function setDynamicFontSize() {
            subtitle.style.fontSize = (24/428)*audioContainer.clientWidth + "px";
            Array.from(transcriptDiv.getElementsByClassName('text')).forEach((text)=>{
                if(text.parentElement.classList.value.includes('current')){
                    text.style.fontSize = (21/428)*audioContainer.clientWidth + "px";
                } else{
                    text.style.fontSize = (16/428)*audioContainer.clientWidth + "px";
                }
            });   
        }

        function positionAudioPlayer() {

            if(isMaximizedPlayer) {
                position.y = 0;
            } else {
                position.x = (contentContainer.offsetWidth - (audioContainer.offsetWidth || 428))/2;
                position.y = (contentContainer.offsetHeight - (audioContainer.offsetHeight || 168))/2;
                if(window.innerWidth < 576) {
                    position.x = 16; // audio container width is 100% - 32px, so half of it will be 16px.
                    position.y = 0;
                }
            }

            position.y = Math.round(position.y);
            position.x = Math.round(position.x);
            audioContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
            centerAudioPlayerIfOutOfBoundsWhileDrag();

        }

    /************************************************************************************************* */
    /********************************Audio Subtitle and Transcripts End ****************************** */
    /************************************************************************************************* */


        // #333 : Selection Deletion feature not working properly with Audio\Video 

        overlayContainer.removeAllListeners();
        overlayContainer.addEventListener('mouseup', function(e) {
            let evt = document.createEvent('HTMLEvents');
            evt.initEvent('mouseup', false, true);
            let imagebookWrapper = document.querySelector('#imgbook_wrapper');
            imagebookWrapper && imagebookWrapper.dispatchEvent(evt);
        });

        overlayContainer.addEventListener('toc-open-event', function(event) {

            const tocWidth = 320;

            let outerContainer = document.querySelector('.outer-container');
            let isContentScrollable = Math.abs(outerContainer.offsetWidth - outerContainer.scrollWidth) > 1 ? true : false;

            let audioContainerBoundingRect = audioContainer.getBoundingClientRect();
            let contentContainerBoundingRect = contentContainer.getBoundingClientRect();


            if(isContentScrollable) {

                if(event.detail.tocPosition == 'left') {
                
                    if(audioContainerBoundingRect.right > contentContainerBoundingRect.right) {
                        position.x -= (audioContainerBoundingRect.right - contentContainerBoundingRect.right);
                    } else {

                        // empty else block
                        // if(audioContainerBoundingRect.right + tocWidth/2 > contentContainerBoundingRect.right) {
                        //     position.x += Math.abs(audioContainerBoundingRect.right - contentContainerBoundingRect.right);
                        // } else {
                        //     position.x += tocWidth/2;
                        // }

                    }

                    position.x = Math.round(position.x);
                    position.y = Math.round(position.y);
                    audioContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
                    
                } else if(event.detail.tocPosition == 'right') {
                
                    if(audioContainerBoundingRect.left < contentContainerBoundingRect.left) {
                        position.x += (contentContainerBoundingRect.left - audioContainerBoundingRect.left);
                    } else {
                        if(audioContainerBoundingRect.left - tocWidth/2 < contentContainerBoundingRect.left) {
                            position.x -= Math.abs(audioContainerBoundingRect.left - contentContainerBoundingRect.left);
                        } else {
                            position.x -= tocWidth;
                        }
                    }

                    position.x = Math.round(position.x);
                    position.y = Math.round(position.y);
                    audioContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
    
                }

            } else {

                if(audioContainerBoundingRect.right > contentContainerBoundingRect.right) {
                    position.x -= (audioContainerBoundingRect.right - contentContainerBoundingRect.right);
                }else if(audioContainerBoundingRect.left < contentContainerBoundingRect.left) {
                    position.x += (contentContainerBoundingRect.left - audioContainerBoundingRect.left );
                }

                position.x = Math.round(position.x);
                position.y = Math.round(position.y);
                audioContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
                    
            }

            setSliderBackground();

        });

        overlayContainer.addEventListener('toc-close-event', function(event) {
            
            const tocWidth = 320;

            let audioContainerBoundingRect = audioContainer.getBoundingClientRect();
            let contentContainerBoundingRect = contentContainer.getBoundingClientRect();

            if(event.detail.wasContentScrollable) {

                if(event.detail.lastTocPosition == 'left') {

                    if(audioContainerBoundingRect.right + tocWidth/2 >= contentContainerBoundingRect.right) {
                        // empty if block
                        // requirements changed
                    } else {
                        // empty else block
                        // position.x -= tocWidth/2;
                    }

                    position.x = Math.round(position.x);
                    position.y = Math.round(position.y);
                    audioContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
                    
                } else if(event.detail.lastTocPosition == 'right') {

                    if(audioContainerBoundingRect.left - tocWidth/2 <= contentContainerBoundingRect.left) {
                        // empty if block
                        // requirements changed
                    } else {
                        position.x += tocWidth;
                    }

                    position.x = Math.round(position.x);
                    position.y = Math.round(position.y);
                    audioContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";

                }

            }

            setSliderBackground();

        });

        overlayContainer.style.display = 'flex';
        closePlayer.addEventListener("click", function() {
            dlsAudioPlayer.destroyPlayer();
        });
        closeMobilePlayer.addEventListener("click", function() {
            dlsAudioPlayer.destroyPlayer();
        });
        closeMobileTitleBar.addEventListener("click", function() {
            dlsAudioPlayer.destroyPlayer();
        });

        // disable subtitle and transcipt for hotspot type =="audio"
        _disableSubtitles(options.jsonData.type);

        // reset the volume controls to default volume control
        player.volume = 1;
        player.muted = false;

        player.speed = 1;

        dlsAudioPlayer.player = player;
        setTimeout(function() {
            var progressBackground = document.getElementById("progress-background");
            progressBackground.style.width = document.querySelector('.audio-progress-bar').clientWidth + "px";
            progressBackground.style.backgroundSize = "6.5px 5px, " + document.querySelector('.audio-progress-bar').clientWidth +  "px 5px";
        }, 100);
        
        resizeEventListener = function() {
            setTimeout(function() {
                //  set start flag and end flag location
                if(loopConfig.active) {
                    var totalWidth = document.getElementsByClassName("plyr__progress")[0].clientWidth;
                    // start flag
                    var startFlag = document.getElementsByClassName("start-flag")[0];
                    startFlag.style.display = "block";
                    startFlag.style.left = loopConfig.startPoint*totalWidth + "px";
                    
                    //end flag
                    var endFlag = document.getElementsByClassName("end-flag")[0];
                    endFlag.style.display = "block";
                    endFlag.style.left = loopConfig.endPoint*totalWidth + "px";
                }
                var progressBackground = document.getElementById("progress-background");
                if(progressBackground){
                    progressBackground.style.width = document.querySelector('.audio-progress-bar').clientWidth + "px";
                }
                // set background colour and gradient color if loop is active
                setSliderBackground();
            }, 100);

            if(window.innerHeight < audioContainer.clientHeight + 64 + 40 || window.innerWidth < 576) {
                audioContainer.style.height = 'auto';

                // transcriptContainer height calculated as...
                // audio player component height = 114px + 40px padding
                // title bar height = 56px 
                // marign between all components = 8px 
                // total height = 226px
                
                transcriptContainer.style.maxHeight = audioContainer.clientHeight - 226 + "px";
            }

            if(window.innerWidth <576 && showSubs && !isMaximizedPlayer) {
                enterFullScreenCommonHandler(true);
            }

            if(window.innerWidth <576 && showtrans && !isMaximizedPlayer) {
                enterFullScreenCommonHandler(true);
            }
           
            audioContainer.style.maxWidth = window.innerWidth + 'px';
           
            if(orientationChangeCausedResize) {
                orientationChangeCausedResize = false;
                wasDragged = false;
                
                positionAudioPlayer();
                
                position.x = 0;

                position.x = Math.round(position.x);
                position.y = Math.round(position.y);
                audioContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
            }

            setDynamicFontSize();
            positionAudioPlayer();

        }

        window.addEventListener("resize", resizeEventListener);
        
        // document.querySelector('#audioSource').addEventListener('error', (err) => {

        //     if(closeAndReopen) {
        //         return;
        //     }

        //     if(dlsAudioPlayer.player) {
        //         closePlayer.click();
        //     }

        //     let t = Date.now();
        //     console.log(t - timeAtLaunch);
        //     if( t - timeAtLaunch <= 500) {
                
        //         // $('#assetErrorModal').attr('missing','audio');
                
        //         if(options.events.navigateToDashboard) {
        //             options.events.navigateToDashboard();
        //         }
        //         $('#assetErrorModal').modal('show');
        //     }

        // });
    }

    function _disableSubtitles(type) {
        let subtitleButton = document.getElementById("subtitle-button");

        let transcriptButton = document.getElementById("transcriptBtn");

        if(type == "audio") {            
            if(!subtitleButton.classList.contains('disabled'))  {
                subtitleButton.classList.add("disabled");
            }
            if(!transcriptButton.classList.contains('disabled'))  {
                transcriptButton.classList.add("disabled");
            }

            subtitleButton.style.cursor = "default";
            transcriptButton.style.cursor = "default";
            
        } else {

            if(subtitleButton) {
                if(subtitleButton.classList.contains('disabled')) 
                    subtitleButton.classList.remove("disabled");
                subtitleButton.style.cursor = "";
            }

            if(transcriptButton) {
                if(transcriptButton.classList.contains('disabled')) 
                    transcriptButton.classList.remove("disabled");
                transcriptButton.style.cursor = "";
            }

        }

    }

    function destroyPlayer() {
        let audio = document.querySelector('#audio-player');
        if (audio) {
            audio.pause();
            audio.src = "";
            audio.removeAttribute('src');
            let audioSrc = document.querySelector('#audio-player').querySelector('source');
            audioSrc.src = "";
            audioSrc.removeAttribute('src');
            audio.load();
        }

        var overlayContainer = document.querySelector('.overlay-container');
        if(overlayContainer){
            overlayContainer.classList.remove('mobile-audio-player');
            overlayContainer.classList.remove('mobile-fullscreen-entered');
            overlayContainer.classList.remove('sidebar-open-left');
            overlayContainer.classList.remove('sidebar-open-right');
            overlayContainer.innerHTML = "";
            overlayContainer.style.display = 'none';
        }
        dlsAudioPlayer.player.destroy();
        window.removeEventListener("orientationchange", orientationChangeEventListener);
        window.removeEventListener("resize", resizeEventListener);
        dlsAudioPlayer.player = undefined;
        if(dlsAudioPlayer.options.onClose){
            dlsAudioPlayer.options.onClose();
        }
        document.removeEventListener("click", closeAudioSettingsHandler);
        document.removeEventListener("keydown", keyboardEventHandler);
    }

    window.dlsAudioPlayer = {
        "launchPlayer" : launchPlayer,
        "destroyPlayer": destroyPlayer,
        "player" : undefined
    };


})();